import React from 'react';
import styles from './CompanyInfoText.module.scss';

const CompanyInfoText: React.FC = () => {
  const telNumber = '0120-089-884';
  return (
    <div className={styles.company}>
      <a href={`tel:${telNumber.replace(/-/g, '')}`} className={styles.company__tel}>
        {telNumber}
      </a>
      <p className={styles.company__hour}>受付時間 9:00〜18:00（土日祝除く）</p>
    </div>
  );
};

export default CompanyInfoText;
